import React from 'react';
import { Image } from '@douyinfe/semi-ui';
import { Icon } from 'tdesign-icons-react';

const UniImage = ({ src, width = 'auto', height = 'auto', style = {}, className = '', alt = '' }) => {
    // 检查是否是TDesign图标格式：t-icon-xxx,#fff,16
    const isTDesignIcon = src && typeof src === 'string' && src.startsWith('t-icon-');

    if (isTDesignIcon) {
        // 解析图标格式：t-icon-xxx,#fff,16
        const [iconName, color, size] = src.split(',');

        // 参考ImageSelector中的格式处理逻辑
        const formatIconName = (name) => {
            return name.replace(/-(filled|stroke)$/, '');
        };

        const iconNameClean = formatIconName(iconName.replace('t-icon-', ''));

        const IconName = formatIconName(iconNameClean);

        // 尝试渲染TDesign图标
        try {
            return (
                <div
                    className={className}
                    style={{
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width,
                        height,
                        ...style
                    }}
                >
                    <Icon
                        name={IconName}
                        size={size ? parseInt(size) : 16}
                        color={color || '#000'}
                    />
                </div>
            );
        } catch (error) {
            console.error('Failed to render TDesign icon:', error);
            // 如果图标渲染失败，显示一个占位符
            return (
                <div
                    className={className}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width,
                        height,
                        backgroundColor: '#f5f5f5',
                        color: '#999',
                        fontSize: '12px',
                        ...style
                    }}
                >
                    图标加载失败
                </div>
            );
        }
    }

    // 如果不是TDesign图标格式，则当作普通图片处理
    return (
        <Image
            preview={false}
            src={src}
            width={width}
            height={height}
            maxWidth={'100%'}
            maxHeight={'100%'}
            style={style}
            className={className}
            alt={alt}
            fallback={
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    backgroundColor: '#f5f5f5',
                    color: '#999',
                    fontSize: '12px'
                }}>
                    图片加载失败
                </div>
            }
        />
    );
};

export default UniImage;